import { useEffect, useState } from 'react';

export const useMaskedPhoneDisplay = ({ value }) => {
  const [isEditing, setIsEditing] = useState(false);

  const isMasked = typeof value === 'string' && value.includes('*');

  useEffect(() => {
    if (!value) setIsEditing(false);
  }, [value]);

  const enterEditMode = () => {
    if (!isEditing) setIsEditing(true);
  };

  const exitEditMode = () => {
    if (isMasked) setIsEditing(false);
  };

  return {
    isMasked,
    isEditing,
    showLiveInput: !isMasked || isEditing,
    enterEditMode,
    exitEditMode,
  };
};
